import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import { SupportTasksToolbarFilters } from './supportTasksToolbarFilters';

export const SupportTasksToolbar = observer(() => {
  return (
    <Grid container spacing={2} alignItems="flex-end">
      <Grid item>
        <SupportTasksToolbarFilters />
      </Grid>
    </Grid>
  );
});
